<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>  
              <v-card-title>      
                {{ 'Documents' | translate }}
              </v-card-title>
              <v-divider></v-divider>     
              <v-row>
                <v-col cols='12' sm='8' md='8'>
                  <v-expansion-panels>
                    <v-expansion-panel class="mb-5" v-for="(coursedata, index) in courses" :key="index" @click="getDocuments(coursedata.course_id)">
                      <v-expansion-panel-header>{{ coursedata.course_name }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <Progress v-if="loadingdata" />
                       <v-list v-else>
                          <v-list-item
                            v-for="item in generaldocuments"
                            :key="item.gendoc_id"
                          >
                            <v-list-item-content>
                              <v-list-item-title v-text="item.gendoc_name"></v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-btn small color="primary" @click='openDocument(item.hash_id)'>
                                {{'View' | translate}}
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list> 
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_COURSES, FETCH_GENERAL_DOCUMENTS , RESET_STATE } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type"
export default {
  name: "Documents",
  beforeRouteEnter(to, from, next) {
    Promise.all([
       store.dispatch(RESET_STATE),
       store.dispatch(FETCH_COURSES,"?is_subscribed=true")
      ]).then(() => {
        store.commit(SET_LOADING, false)
      })
    return next();
  },

  computed: {
    ...mapGetters(['courses','loadingdata','generaldocuments'])
  },
  components: {
    Progress: () => import("@/components/progress/progress"),
  },
  data() {
    return {
    };
  },
  methods: {
    async getDocuments(id){
      await this.$store.dispatch(FETCH_GENERAL_DOCUMENTS,'?course_id='+id).then(resp =>{
        if(resp != undefined && resp.success == true){
          this.$store.commit(SET_LOADING)
        }
      })
    },
    openDocument(hashid){
      this.$router.push('/documents/'+hashid)
    }
  }

}
</script>
